





























































































import {
  BSidebar,
  BForm,
  BButton,
  BFormGroup,
  BFormInput,
  BSpinner,
  BFormFile
} from "bootstrap-vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { OutilSuiviEnvTravailCreateModel } from "@/api/models/outilsSuiviEnvTravail/outilSuiviEnvTravail";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";

@Component({
  components: {
    BSidebar,
    BSpinner,
    BButton,
    BFormInput,
    BForm,
    BFormGroup,
    ValidationProvider,
    ValidationObserver,
    BFormFile
  },
  name: "create-outil-suivi-env-travail",
})
export default class CreateOutilSuiviEnvTravail extends Vue {
  @Prop({ required: true, type: Boolean })
  isAddNewOutilSuiviEnvTravailSidebarActive!: boolean;
  loading = false;

  required = required;

  newOutilSuiviEnvTravail: OutilSuiviEnvTravailCreateModel = {};

  resetForm() {
    this.newOutilSuiviEnvTravail = {};
  }

  async submit() {
    this.loading = true;
    await this.$http.myressif.entreprises
      .createOutilSuiviEnvTravailEntreprise(this.$route.params.id, this.newOutilSuiviEnvTravail)
      .then(
        async (response: any) => {
          successAlert.fire({
            timer: 3500,
            title: "Création d'un outil de suivi environnement de travail",
            text: "Outil de suivi environnement de travail créé avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-outils-suivi-env-travail");
        this.$emit("update:is-add-new-outil-suivi-env-travail-sidebar-active", false);
        this.loading = false;
      });
  }
}
